<template>
    <form method="GET" action="/events/" class="search-form" x-data="{ searchModal: '', selectedCategories: [], selectedLocations: [] }" id="search-form">
        <div class="modal modal--filters" v-if="showModal == 'categories'"> 
            <div class="modal__background"></div>
            <div class="modal__content">
                <a href="#" class="modal__close" v-on:click.prevent="showModal = ''"><i class="fa-light fa-xmark"></i></a>
                <h2 class="modal__title tw-text-xl tw-text-brand-blue tw-font-medium tw-tracking-wide">Categories</h2>
                <div class="modal__inner tw-py-6">
                    <label v-for="category in categories"><input type="checkbox" :value="category.slug" v-model="selectedCategories"> {{ category.name }}</label>
                </div>
                <div class="modal__footer"><button class="btn btn--primary" v-on:click.prevent="showModal = ''">Select</button></div>
            </div>
        </div>
        <div class="modal modal--filters" v-if="showModal == 'locations'"> 
            <div class="modal__background"></div>
            <div class="modal__content">
                <a href="#" class="modal__close" v-on:click.prevent="showModal = ''"><i class="fa-light fa-xmark"></i></a>
                <h2 class="modal__title tw-text-xl tw-text-brand-blue tw-font-medium tw-tracking-wide">Locations</h2>
                <div class="modal__inner tw-py-6">
                    <label v-for="location in locations"><input type="checkbox" :value="location.slug" v-model="selectedLocations"> {{ location.name }}</label>
                </div>
                <div class="modal__footer"><button class="btn btn--primary" v-on:click.prevent="showModal = ''">Select</button></div>
            </div>
        </div>
        <div class="container mx-auto">
            <div class="tw-flex tw-flex-wrap md:tw-flex-nowrap tw-justify-center -tw-mx-3">

                <div :class="(hideLocations ? 'tw-mt-4 md:tw-mt-0 tw-w-full md:tw-w-5/12 tw-px-3' : 'tw-mt-4 md:tw-mt-0 tw-w-full md:tw-w-1/3 tw-px-3')">
                    <label>Filter by dates</label>
                    <input type="text" class="option-selector" id="datepicker" v-model="dates">
                </div>
                <div class="tw-mt-4 md:tw-mt-0 tw-w-full md:tw-w-2/12 tw-px-3">
                    <label class="tw-hidden md:tw-block">&nbsp;</label>
                    <button v-on:click.prevent="runFilters" class="btn btn--primary">Find Events</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { easepick } from "@easepick/core"
import { RangePlugin } from "@easepick/range-plugin"
import { LockPlugin } from "@easepick/lock-plugin"
import moment from "moment"
export default {
    components: {
     
    },

    data() {
        return {
            showModal: false,
            selectedCategories: [],
            selectedLocations: [],
            selectedStartDate: '',
            selectedEndDate: '',
            picker: null,
            dates: ''
        }    
    },

    props: ['categories', 'locations', 'selections', 'hideLocations'],

    mounted() {
        this.setupDatePicker();
        this.setSelections();
        
    },

    methods: {
        setupDatePicker(){
            let self = this;

            this.picker = new easepick.create({
                element: "#datepicker",
                css: [
                    "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css",
                    "/wp-content/themes/theme.glenntaylor.digital/build/datepicker.css"
                ],
                zIndex: 10,
                plugins: [
                    RangePlugin,
                    LockPlugin
                ],
                LockPlugin: {
                    minDate: moment().format()
                },
                format: "DD/MM/YYYY",
                
            });

            this.picker.on('select', (e) => {
                let start = moment(e.detail.start);
                let end = moment(e.detail.end);

                self.selectedStartDate = start.format('YYYY-MM-DD');
                self.selectedEndDate = end.format('YYYY-MM-DD');
            });
        },
        runFilters(){
            let url_parts = [];

            if(this.selectedCategories.length){
                url_parts.push('categories=' + this.selectedCategories.join(','));
            }

            if(this.selectedLocations.length && !this.hideLocations){
                url_parts.push('locations=' + this.selectedLocations.join(','));
            }

            if(this.selectedStartDate && this.selectedEndDate){
                url_parts.push('from=' + this.selectedStartDate);
                url_parts.push('to=' + this.selectedEndDate);
            }

            let path = window.location.pathname;

            if(path.substring(0, 7) == '/events' && path.length > 8){
                path = '/events/';
            }else if(path == '/'){
                path = '/events/';
            }

            window.location = path + '?' + url_parts.join('&');
        },
        setSelections(){
            if(this.selections.categories && this.selections.categories.length){
                this.selectedCategories = this.selections.categories;
            }

            if(this.selections.locations && this.selections.locations.length){
                this.selectedLocations = this.selections.locations;
            }

            if(this.selections.dates){
                this.dates = this.selections.dates;
                this.picker.setDateRange(this.selections.from, this.selections.to);
            }
        }
    },

    computed: {
    }
}
</script>

<style scoped lang="scss">
    .slide-out{
        @apply tw-fixed tw-left-0 tw-top-0 tw-w-full tw-h-full;
        z-index: 999;

        &__background{
            @apply tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-bg-opacity-30 tw-bg-black tw-backdrop-blur-sm;
        }

        &__content{
            @apply tw-w-1/3 tw-absolute tw-left-0 tw-top-0 tw-h-full  tw-bg-white tw-p-8;
        }

        &__close{
            @apply tw-absolute tw-top-8 tw-right-8
        }
    }
</style>